import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { addMonths, format, parseISO } from 'date-fns';
import Footer from './Footer';
import Header from './Header';

function PrivacyPolicy() {
 
  
  return (
    <div className="container mx-auto">
          <Header></Header>
          <div className="p-10 text-sm/7">
      <div className="space-y-3 p-4">
        <p className="font-bold">Privacy Policy for MemberMeld - A Complete Member &  Membership management solution at Your Fingertips</p>
        <p><span className="font-bold">Last updated:</span> June 1st, 2025</p>

        <div>
          <p className="font-bold">1. Introduction</p>
          <p>Welcome to MemberMeld ("MemberMeld", "we", "us", or "our"). MemberMeld is a product owned and operated by Reyspire Digital Software Private Limited, a registered buisness in India.</p>
          </div>
        <p>Your privacy is important to us. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our MemberMeld application.</p>
        <p>By accessing or using our Service, you agree to the terms outlined in this Privacy Policy. If you do not agree, you may not use our services.</p>
        <p>If you have any questions, you can contact us at <a href="mailto:support@membermeld.com" target="_blank" rel="noopener noreferrer" className="text-[#00A6FB] hover:text-red-500">support@membermeld.com</a></p>

        <div>
          <p className="font-bold">2. Information We Collect</p>
          <p>We collect various types of information to provide and improve our Service, including:</p>
        </div>
        <div>
          <p><span className="font-bold">•	Personal Information: </span>Name, email address, phone number, and other identifying details provided during registration.</p>
          <p><span className="font-bold">•	Membership Information: </span>Membership status, membership plan, renewal details, and expiration dates.</p>
          <p><span className="font-bold">•	Attendance Data: </span>Records of member attendance for tracking and reporting purposes.</p>
          <p><span className="font-bold">•	Camera and Gallery Usage: </span>While using our application, and with your prior permission, we may collect images and related information from your device’s camera and photo library to enable certain features of the app. This data is used to enhance and personalize your experience with our services. It may be stored locally on your device or uploaded to our servers or those of our service providers.</p>
          <p>You can manage or revoke access to this information at any time through your device’s settings.</p>
          <p><span className="font-bold">•	Payment Information: </span>Payment history, due dates, and reminders for pending payments (Note: We do not store credit/debit card details; payments are processed through secure third-party providers). We do not gather sensitive financial information, such as bank account details obtained through external connections.</p>
          <p><span className="font-bold">•	Inquiry Information: </span>Details of inquiries submitted by members or prospective users.</p>
          <p><span className="font-bold">•	Expense Records: </span>Any financial records related to membership management, such as operational costs.</p>
          <p><span className="font-bold">•	Device and Usage Information: </span>IP address, browser type, and other technical data when you use the application.</p>
        </div>

        <div>
          <p><span className="font-bold">3. How We Use Your Information </span>We use the collected information to:</p>
          <p>•	Manage memberships, including registration, renewals, and cancellations.</p>
          <p>•	Track and monitor attendance.</p>
          <p>•	Process and manage payments, dues, and financial transactions.</p>
          <p>•	Send reminders for membership renewals and pending payments.</p>
          <p>•	Respond to inquiries and provide customer support.</p>
          <p>•	Improve our Service functionality and user experience.</p>
          <p>•	Manage user authentication (Google Sign-In, Apple Sign-In, email/password)</p>
          <p>•	Comply with legal obligations.</p>
          <p>•	We do not use your data for marketing, advertising, or third-party sales.</p>
        </div>

        <div>
          <p className="font-bold">4. How We Share Your Information </p>
          <p>We do not sell, trade, or rent your personal data. However, we may share your information with:</p>
          <p><span className="font-bold">•	Service Providers: </span>Third-party payment processors and hosting services that help operate our platform.</p>
          <p><span className="font-bold">•	Legal Authorities: </span>When required by law or to protect the rights, safety, and property of our users and the public.</p>
          <p><span className="font-bold">•	Business Transfers: </span>In the event of a merger, sale, or acquisition, your data may be transferred to the new entity.</p>
          
        </div>

        <div > 
          <p><span className="font-bold">5. Data Security </span>We implement security measures to protect your data from unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the internet is 100% secure.</p>
        </div>

        <div>
          <p className="font-bold">6. Payments & Subscription Model</p>
          <p>•	MemberMeld does not store or process any payment information, including credit card or billing details.</p>
          <p>•	All transactions are securely managed by Razorpay, in accordance with their respective privacy and security policies <a href="https://razorpay.com/privacy" target="_blank" className="text-[#00A6FB] hover:text-red-500" rel="noopener noreferrer">Privacy Policy </a> &
          <a href="https://razorpay.com/terms" target="_blank" className="text-[#00A6FB] hover:text-red-500" rel="noopener noreferrer"> Terms and Conditions.</a>
          </p>
          <p>•	MemberMeld operates on a subscription-based model, offering a free trial followed by paid plans available on a monthly, quarterly, yearly, or other selectable basis.</p>
          <p>•	To manage or cancel your subscription, contact us at <a href="mailto:support@membermeld.com" target="_blank" rel="noopener noreferrer" className="text-[#00A6FB] hover:text-red-500">support@membermeld.com</a></p>
        </div>

        <div>
          <p className="font-bold">7. User Consent</p>
          <p>User consent is obtained during the onboarding process, where necessary information is provided to enable core app functionality. By submitting your data and using MemberMeld, you acknowledge and agree to the terms outlined in this Privacy Policy.</p>
        </div>

        <div>
          <p><span className="font-bold">8. Your Rights and Choices </span>You have the right to:</p>
          <p>•	Access, correct, or delete your personal information.</p>
          <p>•	Optout of marketing communications.</p>
          <p>•	Request data portability, where applicable.</p>
          <p>•	Restrict or object to certain data processing activities.</p>
          <p>To exercise these rights, contact us at <a href="mailto:support@membermeld.com" target="_blank" rel="noopener noreferrer" className="text-[#00A6FB] hover:text-red-500">support@membermeld.com</a></p>
        </div>

        <div>
          <p><span className="font-bold">9. Data Retention </span>We retain your information as long as necessary to fulfil our service obligations or comply with legal requirements. Once no longer needed, we securely delete or anonymize the data.</p>
        </div>

        <div>
          <p><span className="font-bold">10. Third-Party Links </span>Our Service may contain links to third-party websites. We are not responsible for the privacy practices of these external sites.</p>
        </div>

        <div>
          <p><span className="font-bold">11. Updates to This Privacy Policy </span>We may update this Privacy Policy from time to time. Changes will be posted with a revised effective date. Your continued use of the Service after updates signifies acceptance of the changes.</p>
        </div>

        <div>
          <p><span className="font-bold">12. Contact Us </span>For any questions or concerns about this Privacy Policy, contact us at: </p>
          <p><span className="font-bold">Email: </span><a href="mailto:support@membermeld.com" target="_blank" rel="noopener noreferrer" className="text-[#00A6FB] hover:text-red-500">support@membermeld.com</a></p>
          <p><span className="font-bold">Website: </span><a href="https://membermeld.com" target="_blank" rel="noopener noreferrer" className="text-[#00A6FB] hover:text-red-500">https://membermeld.com</a></p>
        </div>
      </div>
    </div>
      <Footer></Footer>
    </div>
  );
  
}

export default PrivacyPolicy;
